/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */

type EnvironmentVariables = {
  API_BASE_PATH: string;
  AUTH_CLIENT_ID: string;
  AUTH_AUTHORITY: string;
  AUTH_API_SCOPES: string;
  LOG_TO_DATADOG: boolean;
  DATADOG_CLIENT_KEY: string;
  DATADOG_SITE: string;
  DATADOG_IGNORE_URLS: string[];
  ENVIRONMENT: string;
  SHELL_BACKEND_URL: string;
  SHELL_BACKEND_EXTERNAL_URL: string;
  DEFAULT_SIGN_OUT_REDIRECT_URL: string;
  CUSTOMER_REQUEST_HANDLING_URL: string;
  VERSION_CHECK_INTERVAL: number;
  NEW_VERSION_RELOAD_COUNTDOWN: number;
  IMPORTANT_NEW_VERSION_RELOAD_COUNTDOWN: number;
  SYSTEM_UPDATE_NOTICE_THRESHOLD: number;
  SYSTEM_UPDATE_NOTICE_COUNTDOWN_THRESHOLD: number;
  ENABLE_ITX_CHAT: boolean;
  ENABLE_CUSTOMER_FEEDBACK: boolean;
  GTM_KEY: string;
  ENABLE_GTM_CONSOLE_LOG: boolean;
  ENABLE_INFORMATION_BAR: boolean;
};

type ItxChat = {
  enabled: boolean;
  scriptUrl: string;
  contract: {
    name: string;
    email: string;
  };
};

declare global {
  interface Window {
    ['shell/__env__']: EnvironmentVariables;
    itxChat: ItxChat | null;
  }
}

const environmentVariables = {} as EnvironmentVariables;
window['shell/__env__'] = environmentVariables;

export async function loadConfig(): Promise<void> {
  const envConfig = await fetch('env-config.json').then((res) => res.json());
  for (const k of Object.keys(envConfig)) {
    (environmentVariables as any)[k] = envConfig[k];
  }
}

/* eslint-disable no-underscore-dangle */
export default environmentVariables;
